export const LocationConfig = function ($locationProvider) {
  'ngInject';
  $locationProvider.html5Mode(true);
}